import { Controller } from "@hotwired/stimulus"

// Simple toggle between display and inline edit form.
// Also supports swapping a turbo-frame's content from a <template>.
export default class extends Controller {
  static targets = ["display", "form"]
  static values = { template: String }

  toggle() {
    this.displayTarget.classList.toggle("hidden")
    this.formTarget.classList.toggle("hidden")
  }

  // Replace the closest turbo-frame's content with the content of a <template> element.
  swap() {
    const frame = this.element.closest("turbo-frame")
    const template = document.getElementById(this.templateValue)
    if (frame && template) frame.innerHTML = template.innerHTML
  }
}
